<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Profit Details</h3>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">
              <router-link :to="{ name: 'ProfitAdd'}">
                <button
                  class="btn btn-md btn-primary"
                  style="background-color:white;color:black;"
                >Add New</button>
              </router-link>
            </h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <div class="grid-row" layout="row top-stretch">
                  <div class="grid-cell">
                    <paginator
                      :source="Profit.DataModel.Data.ProfitList"
                      :filter="Profit.GridInfo.ProfitInfoGrid.AdditionalInfo.filter"
                      :page-size="Profit.GridInfo.ProfitInfoGrid.AdditionalInfo.pageSize"
                      data-intro="Use the paginator to page data for easier viewing"
                      data-step="10"
                      data-position="top"
                    >
                      <template scope="page">
                        <datatable
                          id="data-table-main"
                          :source="page.data"
                          :filterable="false"
                          :striped="Profit.GridInfo.ProfitInfoGrid.AdditionalInfo.striped"
                          :editable="Profit.GridInfo.ProfitInfoGrid.AdditionalInfo.editable"
                          :line-numbers="Profit.GridInfo.ProfitInfoGrid.AdditionalInfo.lineNumbers"
                        >
                          <datatable-column
                            v-for="column in Profit.GridInfo.ProfitInfoGrid.columns"
                            :id="column.id"
                            :label="column.label"
                            :width="column.width"
                            :sortable="column.sortable"
                            :groupable="column.groupable"
                            :formatter="column.formatter"
                          ></datatable-column>
                          <!-- <template slot="ProfitRefNo" scope="cell">
                                        <label for="ProfitRefNo" style="width:100% !important" @click="goEdit(cell.row.Id)" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm gridLink"> {{cell.row.ReferenceNo}} </label>
                          </template>-->

                          <!-- <template slot="Date" scope="cell">
                                        <label for="Date" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.Date}} </label>
                          </template>-->
                          <template slot="Date" scope="cell">
                            <label
                              for="Date"
                              style="width:100% !important"
                              @click="GetById(cell.row)"
                              class="Grid-field align-left form-control-sm gridLink"
                            >{{cell.row.Date}}</label>
                          </template>
                          <!-- <template slot="ProfitAmount" scope="cell">
                                        <label for="ProfitAmount" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.ProfitAmount}} </label>
                          </template>-->
                          <template slot="ProfitAmount" scope="cell">
                            <label
                              for="ProfitAmount"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.ProfitAmount}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell">
                                        <label for="Status" style="width:100% !important" :Id="cell.row.Id + '_max'" class="Grid-field align-left form-control-sm"> {{cell.row.Status}} </label>
                          </template>-->
                          <template slot="Status.Name" scope="cell">
                            <label
                              for="Status"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Status.Name}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell" style="padding-left:10px;">


                                         <label class="CompletedStyle" style="margin-left:25px;"> <i class="material-icons CompletedStyle">verified</i> Verified </label>

                          </template>-->
                        </datatable>
                      </template>
                    </paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "Profit",
  data() {
    return {
      Profit: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            ProfitList: [],
            Id: 0,
            Date: null,
            ProfitAmount: null,
            Status: null,
            CustomerId: 1,
            CompanyId: 0,
            BatchId: 0,
            CreatedBy: 1
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0
          }
        },
        GridInfo: {
          ProfitInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null
            },
            AdditionalInfo: {
              striped: true,
              editable: false,
              lineNumbers: false,
              filter: null,
              currency: "USD",
              dateFormat: "D MMMM YYYY",
              selected: [],
              pageSize: 15,
              totalRows: 0
            },
            columns: [
              {
                id: "Date",
                label: "Date",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              },
              {
                id: "ProfitAmount",
                label: "Profit Amount",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              },
              {
                id: "Status.Name",
                label: "Status",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              }
            ]
          }
        },
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.ListProfit();
  },
  methods: {
    ListProfit() {
      let vm = this;
      console.log(this.Profit.DataModel.Data);
      var Token = sessionStorage.getItem("Token");
      this.Profit.DataModel.Data.Token = Token;
      this.Profit.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Profit.DataModel.Data);

      axios
        .post("APIScript/PHP/APIService/Profit/Profit.php", dataString)
        .then(function(response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.Profit.DataModel.Data.ProfitList = response.data.Result;

            vm.Profit.DataModel.Data.ProfitList.map(function(value, key) {
              value.Amount = Utilities.TransactionCurrencyFormat(value.Amount);
            });
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    },
    GetById(data) {
      let vm = this;
      sessionStorage.setItem("SelectedProfitID", data.Id);
      // this.$router.push("/Commodity/CommodityEdit");
      this.$router.push({ name: "ProfitView" });
    }
  }
};
</script>
